module.exports = __webpack_public_path__ + "static/media/copy-link-icon.e4decbf9.svg";